(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("q-floodfill", [], factory);
	else if(typeof exports === 'object')
		exports["q-floodfill"] = factory();
	else
		root["q-floodfill"] = factory();
})(window, function() {
return 